import styles from './Icon.module.scss';
import * as icons from 'assets/icons';
import cx from 'classnames';

export type Icons = keyof typeof icons;

type Props = {
  name: Icons;
  onClick?(): void;
  className?: string;
};

export const Icon = ({ name, onClick, className }: Props) => {
  const IconComponent = icons[name];

  return <IconComponent className={cx(className, { [styles.clickable]: onClick })} onClick={onClick} />;
};
